import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _icons;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import { MathSolverIcon, PrepIcon, QnAIcon, QuickChatIcon, SolutionsIcon, StudyIcon, WritingIcon } from '@chegg-ui/theme';
import { ChevronLink } from '@chegg-ui/link';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from './../../../shared/rio';
import { MegaMenuBadge, MegaMenuIconWrapper } from './styles';
import { supportedIcons } from './types';
var icons = (_icons = {}, _defineProperty(_icons, supportedIcons.math, /*#__PURE__*/React.createElement(MathSolverIcon, null)), _defineProperty(_icons, supportedIcons.writing, /*#__PURE__*/React.createElement(WritingIcon, null)), _defineProperty(_icons, supportedIcons.study, /*#__PURE__*/React.createElement(StudyIcon, null)), _defineProperty(_icons, supportedIcons.prep, /*#__PURE__*/React.createElement(PrepIcon, null)), _defineProperty(_icons, supportedIcons.qna, /*#__PURE__*/React.createElement(QnAIcon, null)), _defineProperty(_icons, supportedIcons.tbs, /*#__PURE__*/React.createElement(SolutionsIcon, null)), _defineProperty(_icons, supportedIcons.tutorsChat, /*#__PURE__*/React.createElement(QuickChatIcon, null)), _icons);
export var MegaMenuItem = function MegaMenuItem(_ref) {
  var icon = _ref.icon,
      link = _ref.link,
      title = _ref.title,
      isNew = _ref.isNew;

  var logClick = function logClick(title) {
    /**
     * Rio logging for a user selecting
     * an item from study-pack dropdown menu
     */
    rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
      data: {
        interaction: {
          type: 'select',
          element: {
            name: 'nav study pack shortcut item',
            type: 'link',
            region_name: "nav study pack header",
            value: title
          }
        }
      }
    }));
  };

  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ChevronLink, {
    adjustToBackgroundColor: "light",
    href: link,
    target: "_blank",
    "data-test": "mega-menu-link",
    onClick: function onClick() {
      return logClick(title);
    }
  }, /*#__PURE__*/React.createElement(MegaMenuIconWrapper, null, icons[icon]), title), isNew && /*#__PURE__*/React.createElement(MegaMenuBadge, null, "New"));
};
MegaMenuItem.displayName = 'MegaMenuItem';
export default /*#__PURE__*/memo(MegaMenuItem);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/MegaMenu/MegaMenuItem.js
// module id = 5588
// module chunks = 11